import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Typography, Tooltip, Button } from '@mui/material';
import { Close, Check, Clear } from '@mui/icons-material';
import { CustomScrollbar } from '@ui/index';
import { FormInstance } from '@unicorn/effector-form';
import * as Styled from './styled';

export type Props<T> = {
  onClose: () => boolean;
  children: JSX.Element | JSX.Element[];
  form: FormInstance<T>;
  isDefaultFilterValues: boolean;
};

export const FiltersTemplate = <T,>({
  onClose,
  children,
  form,
  isDefaultFilterValues,
}: Props<T>) => {
  const { t } = useTranslation();

  const { submit, submittable, reset } = useUnit(form);

  return (
    <Styled.Wrapper elevation={0}>
      <Styled.Toolbar>
        <Typography variant="h3" fontSize={20} fontWeight={500}>
          {t('Filters')}
        </Typography>
        <Tooltip title={t('close')}>
          <Styled.CloseButton onClick={onClose}>
            <Close />
          </Styled.CloseButton>
        </Tooltip>
      </Styled.Toolbar>
      <CustomScrollbar>
        <Styled.Form>{children}</Styled.Form>
      </CustomScrollbar>
      <Styled.Footer>
        <Button
          variant="contained"
          startIcon={<Check />}
          color="primary"
          onClick={submit}
          disabled={!submittable}
        >
          {t('Apply')}
        </Button>
        <Button
          variant="outlined"
          startIcon={<Clear />}
          color="primary"
          onClick={reset}
          disabled={isDefaultFilterValues}
        >
          {t('Reset')}
        </Button>
      </Styled.Footer>
    </Styled.Wrapper>
  );
};
